module.exports = __webpack_public_path__ + "static/media/libby3.0e27411a.png";